import styles from "./styles.module.scss";
import React, {memo} from "react";
import {ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {CourtModel} from "@/app/api/courts";
import PlaceWidget from "@/app/components/place_widget";

interface Props {
  courts: CourtModel[] | undefined
  selectCourt: (courtId: number) => void
}

const PlacesWidget: React.FC<Props> = ({courts, selectCourt}) => {

  return (
    <div className={styles.previousPlaces}>
      <div className={styles.title}>
        <ThirtyText text={t(s.places)}/>
      </div>
      {(courts === undefined || courts.length === 0) && <div className={styles.emptyPage}>
          <ThirtyText text={t(s.nothingYet)}/>
      </div>}
      {courts && courts.length > 0 && courts.map((court, index) => <PlaceWidget key={index} place={court}
                                                                                onClick={() => selectCourt(court.id)}/>)}
    </div>
  );
};

export default memo(PlacesWidget);